function scroll(element) {
    if ($(window).width() > 520) {
	    $('html, body').animate({
	        scrollTop: $(element).offset().top - 60
	    }, 500);
    } else {
    	$('html, body').animate({
	        scrollTop: $(element).offset().top - 44
	    }, 500);
    }
}
$(document).ready(function() {
	$(document).on('click', '.js-anchor', function (event) {
	    event.preventDefault();
		if (!($('.b-header').hasClass('modal'))) {
            $('body').removeClass('is-modal-open');
        }
        $('.b-header').removeClass('menu');
        $('.b-menu').removeClass('active');
        scroll('#' + $(this).attr('data-anchor'));
	});
});
$(window).on('load', function() {
	if (window.location.hash) {
		setTimeout(function() {
            window.scrollTo(0, 0);
        }, 1);
		setTimeout(() => {
			scroll(window.location.hash);
		}, 500);
	}
});


// WEBPACK FOOTER //
// ./src/js/general/anchor.js